export default __webpack_public_path__ + "static/media/connected-services.caa99c88.png";